import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledCreateEditProductsGallery = styled('div')`
  .file-uploader-title {
    font-weight: 600;
    font-size: 16px;
  }

  .ant-upload-text {
    display: flex;
    gap: 5px;
    .gallery-first-text {
      font-size: 14px;
      font-weight: 600;
      color: ${(props) => props.theme.blue};
    }

    .gallery-second-text {
      font-size: 14px;
      color: ${(props) => props.theme.textColor};
      font-weight: 400;
    }
  }

  .ant-upload-drag {
    background: transparent;
    border: none;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23C3C3C3FF' stroke-width='2' stroke-dasharray='8' stroke-dashoffset='9' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 4px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .file-uploader-title {
      font-size: 1rem;
      .ant-upload-text {
        .gallery-first-text {
          font-size: 0.875rem;
        }

        .gallery-second-text {
          font-size: 0.875rem;
        }
      }
    }
  }

  .reqs {
    .req {
      font-size: 0.875rem;
      .intl {
        font-size: 0.875rem;
      }
    }
  }
`;
